import type { SVGProps } from 'react'

export const Warning = (props: SVGProps<SVGSVGElement>) => (
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.0001 22.5576V16.3242"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9984 27.5671C19.7684 27.5671 19.5818 27.7537 19.5834 27.9837C19.5834 28.2137 19.7701 28.4004 20.0001 28.4004C20.2301 28.4004 20.4168 28.2137 20.4168 27.9837C20.4168 27.7537 20.2301 27.5671 19.9984 27.5671"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3817 7.5907L36.1467 29.9307C37.63 32.5274 35.755 35.759 32.765 35.759H7.23501C4.24334 35.759 2.36834 32.5274 3.85334 29.9307L16.6183 7.5907C18.1133 4.97237 21.8867 4.97237 23.3817 7.5907Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
